import {
  CHARGERS_LOADING,
  CHARGERS_ERROR,
  CHARGERS_LIST,
  CHARGERS_FILTERS,

  CHARGERS_ACTION_LOCK,
  CHARGERS_ACTION_UNLOCK,
  // CHARGERS_ACTION_VOICE,
  // CHARGERS_ACTION_OPEN_COVER,
} from "actions/chargers/main/constants";

const initialState = {
  loading: false,
  errors: [],

  filters: [],
  list: {
    content: []
  },
};

export default function (state = initialState, action) {
  switch (action.type) {
    case CHARGERS_LOADING:
      return {
        ...state,
        loading: action.payload.content
      };
    case CHARGERS_ERROR:
      return {
        ...state,
        loading: false,
        errors: action.payload.content
      };
    case CHARGERS_FILTERS:
      return {
        ...state,
        errors: [],
        filters: action.payload.content,
      };
    case CHARGERS_LIST:
      return {
        ...state,
        loading: false,
        errors: [],
        list: action.payload,
      };
    case CHARGERS_ACTION_LOCK:
      return {
        ...state,
        loading: false,
        errors: [],
        list: {
          ...state.list,
          content: state.list.content.reduce((acc, current) => {
            if (current.id === action.payload) {
              current.locked = true;
            }
            return acc.concat(current);
          }, [])
        }
      };
    case CHARGERS_ACTION_UNLOCK:
      return {
        ...state,
        loading: false,
        errors: [],
        list: {
          ...state.list,
          content: state.list.content.reduce((acc, current) => {
            if (current.id === action.payload) {
              current.locked = false;
            }
            return acc.concat(current);
          }, [])
        }
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/chargers/chargerMainReducer.js